<template>
  <div class="set-language">
    <ul>
      <li 
        v-for="(language,code) in $store.state.languages" 
        :alt="language" 
        :key="code"
        :class="{'active': code == $store.state.language_current}"
        @click="setLanguage(code)"
        >
        <img :src="langImages[code]"/>
      </li>
    </ul>
      <!-- <label v-if="title">{{title | setText('Выберите язык интерфейса')}}</label>
      <select class="form-control" name="lang"  @change="setLanguage">
          <option :value="code" :selected="code==$store.state.language_current" v-for="(language,code) in $store.state.languages">{{language}}</option>
      </select> -->
  </div>
</template>
<script>
export default {

  props:{
    title: {
      default:''
    }
  },
  data(){
    return {
      langImages: {
        uz: require('@/assets/img/uz.svg'),
        ru: require('@/assets/img/ru.svg'),
      }
    }
  },
  methods: {
    setLanguage(code){
        this.$loading(true);

        let  lang = code;
        this.$store.dispatch('setLanguageCurrent',event.target.value);
        localStorage.setItem("lang", lang);
        window.location.reload();
    }
  },
};
</script>

<style lang="scss">
  .set-language {
    width:100%;
    margin-top:10px;
    margin-bottom:0;
    ul{
      display: flex;
      justify-content: center;
      li{
        display: inline-block;
        width: 30px;
        margin-left: 5px;
        margin-right: 5px;
      }
    }
  }
</style>

